export default {"src":"/_next/static/media/true-or-false-mini.975f5da4.svg","height":24,"width":24};